// Module
var code = "<ui-v2-embed class=\"embed-page\" src=\"{{overviewSrc}}\" on-load=\"onLoad()\"></ui-v2-embed> ";
// Exports
export default code;